import { ReactNode, createContext, useContext } from 'react';

import { useCreateSalesReturn } from './create-sales-return.hook';

type CreateSalesReturnContextType = ReturnType<typeof useCreateSalesReturn>;

export const CreateSalesReturnContext =
    createContext<CreateSalesReturnContextType | null>(null);

export const CreateSalesReturnProvider = ({
    children,
}: {
    children: ReactNode;
}) => {
    const createSalesReturn = useCreateSalesReturn();
    return (
        <CreateSalesReturnContext.Provider value={createSalesReturn}>
            {children}
        </CreateSalesReturnContext.Provider>
    );
};

export const useCreateSalesReturnContext = () => {
    const context = useContext(CreateSalesReturnContext);
    if (!context) {
        throw new Error(
            'useCreateSalesReturnContext must be used within a CreateSalesReturnProvider',
        );
    }
    return context;
};
